export default __webpack_public_path__ + "static/media/LinkedinIconFooter.2ff43aad.svg";